// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { t } from "@lingui/macro"
import * as Actions from "../actions"
import * as Slice from "../slice"
import { grpc } from "../../../app/rpc/executor"
import { narratePreferencesClient } from "../../../app/rpc/client"
import { showSnackBar } from "../../snackbar/actions"
import { Empty } from "google-protobuf/google/protobuf/empty_pb"
import { NarratePreferences } from "../../../generated/wisetime/user/assistant/v4/preferences_pb"

type GetDefaultNarratePreferencesRpc = () => Observable<NarratePreferences>

export const getDefaultNarratePreferences = (getDefaultNarratePreferencesRpc: GetDefaultNarratePreferencesRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.getDefaultNarratePreferences.match),
      mergeMap(action => of(action.payload).pipe(
        mergeMap(getDefaultNarratePreferencesRpc),
        map(t => t.toObject()),
        map(Slice.setDefaultNarratePreferences),
        catchError(_ => of(showSnackBar({
          message: t({
            id: "msg_get_narrate_preferences_failed",
            message: "Failed to load narrate preferences. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
          }),
          messageType: "ERROR",
        }))),
      )),
    )

const getDefaultNarratePreferencesRpc = (): Observable<NarratePreferences> =>
  grpc(() => narratePreferencesClient.getDefaultNarratePreferences(new Empty(), null))

export default getDefaultNarratePreferences(getDefaultNarratePreferencesRpc)
